function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { loadModule, logger, fill } from '@sentry/utils';
/** Tracing integration for node-mysql package */

var Mysql = /*#__PURE__*/function () {
  function Mysql() {
    _classCallCheck(this, Mysql);

    Mysql.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */


  _createClass(Mysql, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Mysql.id;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      var pkg = loadModule('mysql/lib/Connection.js');

      if (!pkg) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Mysql Integration was unable to require `mysql` package.');
        return;
      } // The original function will have one of these signatures:
      //    function (callback) => void
      //    function (options, callback) => void
      //    function (options, values, callback) => void


      fill(pkg, 'createQuery', function (orig) {
        return function (options, values, callback) {
          var scope = getCurrentHub().getScope();

          var parentSpan = _optionalChain([scope, 'optionalAccess', function (_2) {
            return _2.getSpan;
          }, 'call', function (_3) {
            return _3();
          }]);

          var span = _optionalChain([parentSpan, 'optionalAccess', function (_4) {
            return _4.startChild;
          }, 'call', function (_5) {
            return _5({
              description: typeof options === 'string' ? options : options.sql,
              op: 'db'
            });
          }]);

          if (typeof callback === 'function') {
            return orig.call(this, options, values, function (err, result, fields) {
              _optionalChain([span, 'optionalAccess', function (_6) {
                return _6.finish;
              }, 'call', function (_7) {
                return _7();
              }]);

              callback(err, result, fields);
            });
          }

          if (typeof values === 'function') {
            return orig.call(this, options, function (err, result, fields) {
              _optionalChain([span, 'optionalAccess', function (_8) {
                return _8.finish;
              }, 'call', function (_9) {
                return _9();
              }]);

              values(err, result, fields);
            });
          }

          return orig.call(this, options, values, callback);
        };
      });
    }
  }], [{
    key: "__initStatic",
    value: function __initStatic() {
      this.id = 'Mysql';
    }
  }]);

  return Mysql;
}();

Mysql.__initStatic();

export { Mysql };